import React from 'react';
import Title from '../Title/Title';
import { Icon } from '..';

import './textInput.css';

interface TextInputProps {
    isTextArea?: boolean;
    value: string | number | null;
    error?: string | null;
    name: string;
    placeholder?: string;
    label?: string;
    isDisabled?: boolean;
    type?: string;
    onChange?: (name: string, value: string) => void;
    onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
    onClick?: (event: React.MouseEvent<HTMLElement>) => void;
    onCloseClick?: () => void;
    autoComplete?: string;
    iconName?: string;
    className?: string;
    withCloseIcon?: boolean;
    enableAutocomplete?: boolean;
}

const TextInput: React.FC<TextInputProps> = ({
    isTextArea = false,
    value = null,
    error,
    name,
    placeholder,
    label,
    isDisabled,
    type = 'text',
    onChange = () => {},
    onKeyDown,
    onClick,
    autoComplete,
    iconName,
    className,
    withCloseIcon = false,
    onCloseClick,
    enableAutocomplete = false,
}) => {
    const validateOnChange = (
        event:
            | React.ChangeEvent<HTMLInputElement>
            | React.ChangeEvent<HTMLTextAreaElement>
    ) => {
        onChange(event.target.name, event.target.value);
    };

    const onFocusHandler = (e: React.FocusEvent<HTMLInputElement, Element>) => {
        if (isDisabled) return;

        e.currentTarget.removeAttribute('readonly');
    };

    return (
        <div className="text-input">
            <div className="input-container">
                {label && (
                    <label htmlFor={name}>
                        <Title text={label} size="s" />
                    </label>
                )}
                {!isTextArea ? (
                    <>
                        {iconName && (
                            <Icon
                                name={iconName ? iconName : 'bx-search'}
                                size="22px"
                            />
                        )}
                        <input
                            id={name}
                            name={name}
                            onChange={validateOnChange}
                            onKeyDown={onKeyDown}
                            placeholder={isDisabled ? '' : placeholder}
                            readOnly={!enableAutocomplete}
                            disabled={isDisabled}
                            type={type}
                            value={value || ''}
                            autoComplete={autoComplete}
                            className={`${className} ${error ? 'error' : ''} ${
                                iconName ? 'extra-padding' : ''
                            }`}
                            onClick={onClick}
                            onFocus={onFocusHandler}
                        />
                        {withCloseIcon && (
                            <Icon
                                name="bx-x"
                                cursor="pointer"
                                onClick={onCloseClick}
                                size="20px"
                            />
                        )}
                    </>
                ) : (
                    <textarea
                        id={name}
                        name={name}
                        onChange={validateOnChange}
                        placeholder={isDisabled ? '' : placeholder}
                        readOnly={isDisabled}
                        disabled={isDisabled}
                        value={value || ''}
                    />
                )}
            </div>
            {error && <span className="error-message">{error}</span>}
        </div>
    );
};

export default TextInput;
